const productionStages = [
  { key: "received", label: "Pedido recebido" },
  { key: "printing", label: "Em impressão" },
  { key: "finishing", label: "Em acabamento" },
  { key: "shipped", label: "Enviado" },
  { key: "delivered", label: "Entregue" },
];
const stageIndex = (key) => productionStages.findIndex((stage) => stage.key === key);
function validateProductionUpdate(current, next, note) {
  if (stageIndex(next) < 0) return "Etapa inválida.";
  if (stageIndex(next) !== stageIndex(current) + 1)
    return "Avance uma etapa por vez para manter o histórico de produção.";
  if (typeof note !== "string" || note.length > 1000)
    return "A observação deve ter até 1000 caracteres.";
  return "";
}
module.exports = { productionStages, stageIndex, validateProductionUpdate };
